// Mirrors `App.OfferFeatureSymbol` in www-le-customer (typings/app/offer.d.ts).
// Source of truth — these are the strings the customer renderer's
// `determineOfferFeatureSymbol` accepts. Anything not on this list silently
// renders as no icon on the offer page.
//
// Sorted alphabetically so additions are easy to slot in and duplicates are easy
// to spot. If www-le-customer adds new icons, sync this list (admin won't crash
// on unknown values, but autocomplete won't suggest them).
export const INCLUSION_ICONS = [
  'air_conditioning',
  'apple',
  'balcony',
  'bathtub',
  'beach',
  'bed',
  'bed_with_upwards_arrow',
  'beverage',
  'blender',
  'breakfast',
  'bus',
  'car',
  'check',
  'childs_face',
  'childs_face_with_plus',
  'clock_with_check',
  'clock_with_plus',
  'cloche',
  'coffee',
  'coffee_cup',
  'cook',
  'crossed_utensils',
  'crossed_utensils_with_plus',
  'cutlery',
  'desk',
  'dining_area',
  'dollar_sign_in_circle',
  'dollar_sign_in_circle_with_line_through',
  'drink_tray',
  'dryer',
  'ensuite',
  'fridge',
  'garden',
  'golf',
  'gym',
  'hair_dryer',
  'heat',
  'heating',
  'internet_connection',
  'iron',
  'juice',
  'kettle',
  'key',
  'king_size_bed',
  'kitchen',
  'laundry',
  'line_bed',
  'line_bed_cot',
  'line_check',
  'line_iconic_landmark',
  'line_key_skeleton',
  'line_mountains_road',
  'line_price_tag',
  'line_room_upgrade',
  'line_ship',
  'line_sightseeing',
  'line_university',
  'line_usd_in_circle',
  'lotus',
  'lotus_with_plus',
  'martini_glass',
  'microwave',
  'mobile_android',
  'ocean',
  'outdoor',
  'oven',
  'p_in_circle',
  'parking',
  'plane_departure',
  'plane_with_arrow',
  'plane_with_arrows',
  'plane_with_plus',
  'pool',
  'receipt',
  'seat_with_plane',
  'shower',
  'ski_lift',
  'stereo',
  'stove',
  'sun',
  'tag',
  'taxi',
  'tennis_ball',
  'terrace',
  'toaster',
  'toiletries',
  'tv',
  'underground_parking',
  'wardrobe',
  'washer',
  'washing_machine',
  'wheelchair',
  'wifi',
  'wifi_signal',
  'wind',
  'wine_glass',
  'wine_glass_and_beer_glass',
  'wine_glass_with_clock',
] as const;

export type InclusionIcon = (typeof INCLUSION_ICONS)[number];
